export const GET_CATEGORIES_SELECT_LIST = null;
export const GET_SUB_CATEGORIES_SELECT_LIST = null;

// Super admin

export const GET_CATEGORIES_LIST = null;
export const SELECTED_CATEGORIES_ID = null;
export const GET_CATEGORIES_BY_ID = null;
